<mbs-steps [formGroup]="form">
  <mbs-step
    [number]="1"
    [readOnly]="true"
    [isSimple]="true">
    <ng-container body>
      <div class="d-flex align-items-end">
        <mbs-input
          class="mr-2 col-5"
          formControlName="phone"
          (keyup.enter)="addPhone()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [imaskOpts]="mask"
          [unmask]="true"
          [disabled]="step !== ReserveAuthSteps.SendPhoneCode"
          [boldLabel]="true"
          [label]="'Add phone number'"
          [placeholder]="'shared:placeholders.enterYourPhoneNumber' | i18next"></mbs-input>
        @if (step < ReserveAuthSteps.SendEmailCode) {
          <mbs-button
            [disabled]="step !== ReserveAuthSteps.SendPhoneCode || form.controls.phone.invalid"
            [loading]="stepLoading === ReserveAuthSteps.SendPhoneCode && step === ReserveAuthSteps.SendPhoneCode"
            (click)="addPhone()"
            class="mr-3"
            >Send code
          </mbs-button>
        } @else {
          <mbs-alert
            [type]="MbsPopupType.success"
            [icon]="true"
            class="confirmed-alert m-0"
            >Confirmed</mbs-alert
          >
        }
      </div>

      <mbs-input-errors [errors]="$any(form.controls.phone.errors)"></mbs-input-errors>

      <div
        *ngIf="step === ReserveAuthSteps.ConfirmPhoneCode"
        class="d-flex align-items-end mt-3">
        <mbs-input
          class="col-5"
          formControlName="phoneCode"
          (keyup.enter)="confirmPhone()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [boldLabel]="true"
          [label]="'Verification code'"
          [placeholder]="'shared:placeholders.enterTheCodeFromTheSMS' | i18next"></mbs-input>
        <mbs-button
          class="ml-2 mr-3"
          (click)="confirmPhone()"
          [disabled]="form.controls.phoneCode.invalid"
          [loading]="stepLoading === ReserveAuthSteps.ConfirmPhoneCode"
          >Confirm</mbs-button
        >

        <mbs-reserve-auth-resend-code-button
          *ngIf="step === ReserveAuthSteps.ConfirmPhoneCode"
          (onResend)="addPhone()"
          [loading]="stepLoading === ReserveAuthSteps.SendPhoneCode"
          [seconds]="secondsToResend"></mbs-reserve-auth-resend-code-button>
      </div>

      <mbs-input-errors [errors]="$any(form.controls.phoneCode.errors)"></mbs-input-errors>
    </ng-container>
  </mbs-step>
  <mbs-step
    [number]="2"
    [readOnly]="true"
    [isSimple]="true">
    <ng-container body>
      <div class="d-flex align-items-end">
        <mbs-input
          formControlName="email"
          (keyup.enter)="addEmail()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [boldLabel]="true"
          [label]="'Add recovery email'"
          [placeholder]="'shared:placeholders.enterCurrentOrNewEmail' | i18next"
          [disabledSelf]="step !== ReserveAuthSteps.SendEmailCode"
          [disabled]="step !== ReserveAuthSteps.SendEmailCode"
          class="mr-2 col-5"></mbs-input>
        @if (step <= ReserveAuthSteps.ConfirmEmailCode) {
          <mbs-button
            (click)="addEmail()"
            [disabled]="step !== ReserveAuthSteps.SendEmailCode || form.controls.email.invalid"
            [loading]="stepLoading === ReserveAuthSteps.SendEmailCode && step === ReserveAuthSteps.SendEmailCode"
            class="mr-3"
            >Get code
          </mbs-button>
        } @else {
          <mbs-alert
            [type]="MbsPopupType.success"
            [icon]="true"
            class="confirmed-alert m-0"
            >Confirmed</mbs-alert
          >
        }
      </div>

      <mbs-input-errors [errors]="$any(form.controls.email.errors)"></mbs-input-errors>

      <div
        *ngIf="step === ReserveAuthSteps.ConfirmEmailCode"
        class="d-flex align-items-end mt-3">
        <mbs-input
          class="col-5"
          formControlName="emailCode"
          (keyup.enter)="confirmEmail()"
          [isErrorsShow]="false"
          [showRequiredMark]="false"
          [boldLabel]="true"
          [label]="'Verification code'"
          [placeholder]="'shared:placeholders.enterTheCodeFromTheEmail' | i18next"></mbs-input>
        <mbs-button
          class="ml-2 mr-3"
          (click)="confirmEmail()"
          [disabled]="form.controls.emailCode.invalid"
          [loading]="stepLoading === ReserveAuthSteps.ConfirmEmailCode"
          >Confirm</mbs-button
        >

        <mbs-reserve-auth-resend-code-button
          *ngIf="step === ReserveAuthSteps.ConfirmEmailCode"
          (onResend)="addEmail()"
          [loading]="stepLoading === ReserveAuthSteps.SendEmailCode"
          [seconds]="secondsToResend"></mbs-reserve-auth-resend-code-button>
      </div>

      <mbs-input-errors [errors]="$any(form.controls.emailCode.errors)"></mbs-input-errors>
    </ng-container>
  </mbs-step>
</mbs-steps>
